/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_PaymentsInputs */

const en_student_payments = /** @type {(inputs: Student_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments`)
};

const he_student_payments = /** @type {(inputs: Student_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תשלומים`)
};

/**
* | output |
* | --- |
* | "Payments" |
*
* @param {Student_PaymentsInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const student_payments = /** @type {((inputs?: Student_PaymentsInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_PaymentsInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_student_payments(inputs)
	return he_student_payments(inputs)
});